import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon } from 'lucide-react';
import { CtaButton } from './ui/CtaButton';
import { heroStats } from '../data/landing';
import { heroTomos } from '../data/tomos';
export function Hero() {
  return <header className="relative w-full overflow-hidden bg-[#0f172a]" data-id="element-53" data-mp="9l375k8q6q7o">
      <div className="h-1 w-full bg-gradient-to-r from-[#d97706] via-[#fbbf24] to-[#16a34a]" aria-hidden="true" data-id="element-54" data-mp="4n1lqsntuet1" />
      <div className="pointer-events-none absolute left-1/2 top-0 h-[420px] w-[720px] -translate-x-1/2 rounded-full bg-[#16a34a]/10 blur-[140px]" aria-hidden="true" data-id="element-55" data-mp="128yz6bncnty4" />

      <div className="relative mx-auto w-full max-w-6xl px-6 py-20 text-center sm:py-28" style={{
      paddingTop: "30px",
      paddingBottom: "30px"
    }} data-id="element-56" data-mp="sai2qz5n6n4o">
        <motion.p initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} className="text-[11px] font-semibold uppercase tracking-[0.22em] text-[#22c55e] sm:text-xs" data-id="element-57" data-mp="nekl8pin7aqb">
          El Sistema de Nutrición Atlética más Completo de Argentina
        </motion.p>

        <motion.h1 initial={{
        opacity: 0,
        y: 18
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.08
      }} className="mx-auto mt-6 max-w-2xl font-serif text-3xl font-bold leading-[1.1] text-white sm:text-4xl lg:text-5xl" data-id="element-58" data-mp="3o6kd5bieo01y">
          Come como un Rey con Presupuesto de Estudiante
        </motion.h1>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.16
      }} className="mx-auto mt-10 w-full max-w-[19.6rem]" data-id="element-59" data-mp="358zpg7rdn7ix">
          <img src="https://cdn.magicpatterns.com/uploads/uCgj7Tw2VkEqKNTKipdVPY/mockup.png" alt="Nutricionista sosteniendo el libro Mega Pack Nutrición Bajo Presupuesto, con sello de garantía de devolución total" className="w-full rounded border border-white/10 shadow-[0_30px_80px_-30px_rgba(0,0,0,0.9)]" loading="eager" data-id="element-60" data-mp="2vglmjbokbuv6" />
        </motion.div>

        <div className="mt-9 flex flex-col items-center" data-id="element-61" data-mp="nb1imyt8vhts">
          <CtaButton label="Adquirir Mega Pack Ahora!" data-id="element-62" data-mp="n9i35afexat2" />
          <p className="mt-4 text-xs tracking-wide text-slate-500" data-id="element-63" data-mp="id050tel8app">
            Acceso Inmediato · Descarga Digital · Garantía 7 Días
          </p>
        </div>

        <motion.p initial={{
        opacity: 0,
        y: 18
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.24
      }} className="mx-auto mt-10 max-w-2xl text-base leading-relaxed text-slate-300 sm:text-lg" data-id="element-64" data-mp="1b0nmhzkkal84">
          6 Tomos + 6 Bonos. El sistema que recupera $4.500.000 ARS anuales de tu
          presupuesto alimentario sin reducir calidad nutricional ni rendimiento
          atlético.
        </motion.p>

        <dl className="mx-auto mt-14 grid max-w-4xl grid-cols-2 gap-y-10 border-y border-white/10 py-10 sm:grid-cols-4" data-id="element-65" data-mp="3hrd7mqiwb1xs">
          {heroStats.map(stat => <div key={stat.label} className="px-2 text-center" data-id="element-66" data-mp="1xacinc14tzxg">
              <dt className="sr-only" data-id="element-67" data-mp="21amv97jfjola">{stat.label}</dt>
              <dd data-id="element-68" data-mp="21b63fwja2ym4">
                <span className="block font-serif text-3xl font-bold text-[#22c55e] sm:text-4xl" data-id="element-69" data-mp="218jx2084ip5h">
                  {stat.value}
                </span>
                <span className="mt-2 block text-[11px] uppercase tracking-[0.14em] text-slate-400" data-id="element-70" data-mp="2b1r9u65717fl">
                  {stat.label}
                </span>
              </dd>
            </div>)}
        </dl>

        <ul className="mt-14 grid grid-cols-1 gap-4 text-left sm:grid-cols-2 lg:grid-cols-3" data-id="element-71" data-mp="2kxu8v34r0pyb">
          {heroTomos.map((tomo, index) => <motion.li key={tomo} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.4
        }} transition={{
          duration: 0.4,
          delay: index * 0.05
        }} className="flex items-start gap-3 rounded border border-white/10 bg-white/[0.03] p-5 transition-colors duration-200 hover:border-[#16a34a]/40" data-id="element-72" data-mp="2p1a4bw530k9f" data-mpi={index}>
              <BookOpenIcon className="mt-0.5 h-5 w-5 shrink-0 text-[#d97706]" aria-hidden="true" data-id="element-73" data-mp="3vi6yekswiato" />
              <span className="text-sm font-medium leading-snug text-slate-200" data-id="element-74" data-mp="ea3gne5nk47i">
                {tomo}
              </span>
            </motion.li>)}
        </ul>
      </div>
    </header>;
}